import { getTenantRuntime } from '../../app/bootstrap/tenantRuntime';

// Preconfigured accounts sign in as `<name>@<tenant>.lineside.test` (ADR-0041).
const MANAGED_SUFFIX = '.lineside.test';

/** The workspace's managed sign-in domain from its public auth config, or null. */
export function managedSignInDomain() {
  const tenant = getTenantRuntime()?.tenant;
  const domain = String(tenant?.managedSignInDomain || '').trim().replace(/^@/, '').toLowerCase();
  return domain || null;
}

/**
 * What the person typed at sign-in, as an email. A short username (no `@`) gets the
 * workspace's managed domain; without that domain it is returned unchanged, so the
 * sign-in still asks for an email.
 */
export function expandSignInName(value) {
  const name = String(value || '').trim();
  const domain = managedSignInDomain();
  return name && domain && !name.includes('@') ? `${name}@${domain}` : name;
}

/** The short form of a managed username in this workspace, else the username as given. */
export function shortManagedUsername(username) {
  const value = String(username || '');
  const domain = managedSignInDomain();
  const suffix = domain ? `@${domain}` : null;
  return suffix && value.toLowerCase().endsWith(suffix) ? value.slice(0, -suffix.length) : value;
}

/** Whether an identity's email is a platform-managed sign-in rather than a person's own. */
export function isManagedSignIn(email) {
  const value = String(email || '').toLowerCase();
  const domain = managedSignInDomain();
  return domain ? value.endsWith(`@${domain}`) : value.endsWith(MANAGED_SUFFIX);
}
